export const formatCurrency = (value = 0, digits = 0) => {
  const numeric = typeof value === 'string' ? Number(value) : value;
  const safeValue = Number.isFinite(numeric) ? numeric : 0;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(safeValue);
};

export const formatDateTimeDisplay = (value) => {
  if (!value) return '--';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '--';
  return date.toLocaleString();
};

export const formatDateInput = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  return date.toISOString().split('T')[0];
};

export const getRangeDates = (range) => {
  const today = new Date();
  const clone = (d) => new Date(d.getTime());

  switch (range) {
    case '30d': {
      const start = clone(today);
      start.setDate(start.getDate() - 29);
      return { startDate: formatDateInput(start), endDate: formatDateInput(today) };
    }
    case '90d': {
      const start = clone(today);
      start.setDate(start.getDate() - 89);
      return { startDate: formatDateInput(start), endDate: formatDateInput(today) };
    }
    case 'ytd': {
      const start = new Date(today.getFullYear(), 0, 1);
      return { startDate: formatDateInput(start), endDate: formatDateInput(today) };
    }
    case 'all':
    default:
      return { startDate: '', endDate: '' };
  }
};

export const createDefaultFilters = () => {
  const dates = getRangeDates('90d');
  return {
    range: '90d',
    startDate: dates.startDate,
    endDate: dates.endDate,
    category: 'all',
    bank: 'all',
  };
};
